// src/store/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import alertSlice from "store/slices/alert-slice"; // Import your slice
import languageReducer from 'store/slices/language-slice';

export const store = configureStore({
	reducer: {
		alert: alertSlice, // Add your slice reducers here
		language: languageReducer,
	},
});

// Define types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
